import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Http, HttpModule, RequestOptions, XHRBackend } from '@angular/http';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { SpinnerModule, SpinnerService } from '@chevtek/angular-spinners';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NguiScrollableModule } from '@ngui/scrollable';
import { TextMaskModule } from 'angular2-text-mask';
import { DragDropDirectiveModule } from 'angular4-drag-drop';
import { Ng2Bs3ModalModule } from 'ng2-bs3-modal/ng2-bs3-modal';
import { ChartsModule } from 'ng2-charts';
import { CurrencyMaskModule } from '@mvpproperties/ng2-currency-mask';
import {
  CURRENCY_MASK_CONFIG,
  CurrencyMaskConfig,
} from '@mvpproperties/ng2-currency-mask/src/currency-mask.config';
import { ToastModule, ToastOptions } from 'ng2-toastr/ng2-toastr';
import { SortableModule, TooltipModule } from 'ngx-bootstrap';
import { QuillModule } from 'ngx-quill';
import { InputMaskModule } from 'primeng/primeng';
import { routing } from './app.route';
import { CustomOption } from './custom-option';

import { AppComponent } from './app.component';
import { AuthComponent } from './auth/auth.component';
import BudgetComponent from './budget/budget.component';
import CashFlowRecordsComponent from './cashflow/cash-flow-records/cash-flow-records.component';
import CashflowComponent from './cashflow/cashflow.component';
// import { CorporateComponent } from './corporate/corporate.component';
import { CoverPageComponent } from './cover-page/cover-page.component';
import { EnterpriseappraisalComponent } from './enterpriseappraisal/enterpriseappraisal.component';
import { FinancialreportsComponent } from './financialreports/financialreports.component';
import FinancingComponent from './financing/financing.component';
import { FooterComponent } from './footer/footer.component';
import { GlossaryComponent } from './glossary/glossary.component';
import { HeaderComponent } from './header/header.component';
import { AddCompanyModalComponent } from './home/addCompanyModal/addCompanyModal.component';
import { HomeComponent } from './home/home.component';
import { InstructionsComponent } from './instructions/instructions.component';
import { InvesorArchitectTableComponent } from './invesor-architect-table/invesor-architect-table.component';
import InvestorarchitectComponent from './investorarchitect/investorarchitect.component';
import { LoanschedulesComponent } from './loanschedules/loanschedules.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { OperatingExpensesTableComponent } from './operating-expenses-table/operating-expenses-table.component';
import OperatingexpensesComponent from './operatingexpenses/operatingexpenses.component';
import { PrintComponent } from './print/print.component';
import { PrintfooterComponent } from './printfooter/printfooter.component';
import { PrintheaderComponent } from './printheader/printheader.component';
import { PrintingComponent } from './printing/printing.component';
import PrintOperatingexpensesComponent from './print-operatingexpenses/print-operatingexpenses.component';
import { ProjectdataTableComponentComponent } from './projectdata-table-component/projectdata-table-component.component';
import { ProjectdataComponent } from './projectdata/projectdata.component';
import RecastComponent from './recast/recast.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import SummaryComponent from './summary/summary.component';
import { TableComponentComponent } from './table-component/table-component.component';
import { UserManagementComponent } from './user-management/user-management.component';

import { AuthService } from './service/auth.service';
import { BudgetService } from './service/budget.service';
import { CashFlowService } from './service/cashflow.service';
import { CloudService } from './service/cloud.service';
import { CommonService } from './service/common.service';
import { CompanyService } from './service/company.service';
import { CookiesService } from './service/cookies.service';
import { EnterpriseService } from './service/enterprise.service';
import { HomeService } from './service/home.service';
import { HttpService } from './service/http.service';
import { LoanService } from './service/loan.service';
import { OperatingexpensesService } from './service/operatingexpenses.service';
import { OtherService } from './service/other.service';
import { PrintService } from './service/print.service';
import { ProjectService } from './service/project.service';
import { ReportingService } from './service/reporting.service';
import { ShareholderService } from './service/shareholder.service';
import { UtilsService } from './service/utils.service';
import { UserService } from './service/user.service';

import { AuthGuard } from './authguard';

import { AdddecimalPipe } from './adddecimal.pipe';
import { CheckdecimalPipe } from './checkdecimal.pipe';
import { CheckmaxvaluePipe } from './checkmaxvalue.pipe';
import { ChecknanPipe } from './checknan.pipe';
import { ChecknumberPipe } from './checknumber.pipe';
import { DecimalplacesPipe } from './decimalplaces.pipe';
import { OptionalPercentPipe } from './optionalPercent.pipe';
import { RoundPipe } from './round.pipe';
import { ShowdashPipe } from './showdash.pipe';
import { ShowdashdollarPipe } from './showdashdollar.pipe';
import { ShownegativePipe } from './shownegative.pipe';

import { TokenInterceptor } from './auth/token.interceptor';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'center',
  allowNegative: false,
  // If we're going to occasionally set someone use negative values, make it so they only have to explicitly set allowNegative.
  allowNegativeZero: true,
  decimal: '',
  precision: 0,
  prefix: '$',
  suffix: '',
  thousands: ',',
};

let httpServiceObj = null;
export function HttpServiceFactoryFunc(
  backend: XHRBackend,
  options: RequestOptions,
  spinnerService: SpinnerService
) {
  if (!httpServiceObj) {
    httpServiceObj = new HttpService(backend, options, spinnerService);
  }
  return httpServiceObj;
}

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    CashflowComponent,
    EnterpriseappraisalComponent,
    OperatingexpensesComponent,
    PrintOperatingexpensesComponent,
    ProjectdataComponent,
    AuthComponent,
    LoginComponent,
    LogoutComponent,
    AddCompanyModalComponent,
    BudgetComponent,
    FinancingComponent,
    RoundPipe,
    ChecknumberPipe,
    CheckdecimalPipe,
    OptionalPercentPipe,
    LoanschedulesComponent,
    SummaryComponent,
    RecastComponent,
    CashFlowRecordsComponent,
    InvestorarchitectComponent,
    InstructionsComponent,
    GlossaryComponent,
    FinancialreportsComponent,
    PrintingComponent,
    PrintComponent,
    PrintheaderComponent,
    PrintfooterComponent,
    TableComponentComponent,
    ProjectdataTableComponentComponent,
    CoverPageComponent,
    InvesorArchitectTableComponent,
    OperatingExpensesTableComponent,
    UserManagementComponent,
    ChecknanPipe,
    //    CorporateComponent,
    ShowdashPipe,
    ShowdashdollarPipe,
    ShownegativePipe,
    DecimalplacesPipe,
    AdddecimalPipe,
    CheckmaxvaluePipe,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ChartsModule,
    QuillModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    Ng2Bs3ModalModule,
    routing,
    InputMaskModule,
    TextMaskModule,
    NguiScrollableModule,
    BrowserAnimationsModule,
    ToastModule.forRoot(),
    NgbModule.forRoot(),
    CurrencyMaskModule,
    TooltipModule.forRoot(),
    DragDropDirectiveModule,
    SortableModule.forRoot(),
    SpinnerModule,
  ],
  providers: [
    HomeService,
    CompanyService,
    AuthService,
    ProjectService,
    CommonService,
    BudgetService,
    OtherService,
    EnterpriseService,
    CashFlowService,
    PrintService,
    AuthGuard,
    OperatingexpensesService,
    LoanService,
    ShareholderService,
    ReportingService,
    UtilsService,
    UserService,
    { provide: ToastOptions, useClass: CustomOption },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    CookiesService,
    {
      provide: Http,
      useFactory: HttpServiceFactoryFunc,
      deps: [XHRBackend, RequestOptions, SpinnerService],
    },
    {
      provide: HttpService,
      useFactory: HttpServiceFactoryFunc,
      deps: [XHRBackend, RequestOptions, SpinnerService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    CloudService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts